import { render, staticRenderFns } from "./StatusAdd.vue?vue&type=template&id=e220725a&scoped=true"
import script from "./StatusAdd.vue?vue&type=script&lang=js"
export * from "./StatusAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e220725a",
  null
  
)

export default component.exports